export const interviewMapping = [
  {
    key: 'isDocumented',
    value: 'Have the incidents of sexual violence experienced been documented?'
  },
  {
    key: 'documentStorage',
    value: 'if so, where are the documents stored?'
  },
  {
    key: 'otherFormsOfViolence',
    value: 'Other forms of sexual violence, please specify'
  },
  {
    key: 'currentImpact_1',
    value: 'How has your daily lives been going?'
  },
  {
    key: 'currentImpact_2',
    value: 'What impact does sexual violence during times of conflict have on your life?'
  },
  {
    key: 'currentImpact_3',
    value: 'Can you talk to your child/spouse/partner/relative about this? Why or why not? How did they react?'
  },
  {
    key: 'currentImpact_4',
    value: 'What impact will this violation have on your economic, social, psychological and cultural life?'
  },
  {
    key: 'currentImpact_5',
    value: 'How did this event impact your children? Has your child been able to continue his school/studies?'
  },
  {
    key: 'currentImpact_6',
    value: 'Do you have safe/secure living situation? Where do you live now? Who with?'
  },
  {
    key: 'currentImpact_7',
    value: 'How has your relationship with the community been impacted by this event?'
  },
  {
    key: 'currentImpact_8',
    value: 'What is the source of strength in your life today?'
  },
  {
    key: 'currentImpact_9',
    value: 'What are your hopes for the future?'
  },
  {
    key: 'currentImpact_10',
    value: 'Is there anything else you\'d like to add?'
  },
  {
    key: 'concordance_ack_1',
    value: 'I agree to be involved in the Community in Leadership project.'
  },
  {
    key: 'concordance_ack_2',
    value: 'I agree that the Community in Leadership Team [Nagarik Aawaz-NWCSC-CVSWDC] may use the information I provide here for the Community In Leadership Program.'
  },
  {
    key: 'concordance_ack_3',
    value: 'I agree to sharing my story and my words/quotes with the following conditions'
  },
  {
    key: 'concordance_ack_3_value_1',
    value: 'My information can be submitted to the Community in Leadership Project Steering Committee/Identification process.'
  },
  {
    key: 'concordance_ack_3_value_2',
    value: 'Pseudonym or code can be used in publications by the Community in Leadership Project'
  },
  {
    key: 'concordance_ack_3_value_3',
    value: 'My quotes and stories can be quoted or cited publicly'
  },
  {
    key: 'acknowledge_1',
    value: 'Yes, I agree that after the Community in Leadership Project ends [in 2026], I am willing to continue to be accompanied by Nagarik Aawaz, meaning. Data about me in the Community in Leadership Project team may continue to be managed by Nagarik Aawaz for the benefit of survivor assistance and advocacy.'
  },
  {
    key: 'acknowledge_2',
    value: 'No, after the Community in leadership Project I do not want to continue mentoring with Nagarik Aawaz; meaning I choose to have all my data deleted or anonymized (without names).'
  },
  {
    key: 'feedback_ack_1',
    value: 'Very strong and able to follow the Participatory Action Research (PAR) process to design and implement the Community in Leadership Project.'
  },
  {
    key: 'feedback_ack_2',
    value: 'Quite powerful but many vulnerabilities.'
  },
  {
    key: 'feedback_ack_3',
    value: 'Very vulnerable, and requires IMMEDIATE attention.'
  },
  {
    key: 'feedbackOtherNotes',
    value: 'Other Notes'
  }
];